import { React } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPersonBiking, faRoad, faMountain, faClock,
} from '@fortawesome/free-solid-svg-icons';

const AggregateStats = ({ data }) => {
  const stat = (icon, value, unit) => (
    <div style={{
      display: 'flex', flexDirection: 'row', padding: '20px', justifyContent: 'center',
    }}
    >
      <div><FontAwesomeIcon icon={icon} className="fa-2x" /></div>
      <div style={{ marginLeft: '20px', marginTop: '5px' }}>
        <h5>
          {Math.round(value).toLocaleString('sk-SK')}
          {' '}
          {unit}
        </h5>
      </div>
    </div>
  );

  const sum = (field) => data.reduce((s, user) => s + user[field], 0);

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, auto)' }}>
      {stat(faPersonBiking, sum('activitiesCnt'), 'jázd')}
      {stat(faRoad, sum('distance'), 'kilometrov')}
      {stat(faMountain, sum('elevation'), 'výškových metrov')}
      {stat(faClock, sum('time') / 3600, 'hodín')}
    </div>
  );
};

AggregateStats.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
};

export default AggregateStats;
